import Request from '@/requests/Request'

const resource = "/indicadores/{indicadorId}/lancamentos/{lancamentoId}/formularios"

export default {
  findFormularios(payload) {
    const url = resource
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
    
    return Request.get(`${url}`)
  },

  postArquivos(payload) {
    const url = resource.concat(payload.urlFormulario).concat("/{formularioId}/arquivos")
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      .replace(new RegExp("{formularioId}", "g"), payload.formularioId)

    let formData = new FormData();
    for (let file of payload.files) {
        formData.append("files", file, file.name);
    }      
      
    return Request.post(`${url}`, formData)
  },

  deleteArquivo(payload) {
    const url = resource.concat(payload.urlFormulario).concat("/{formularioId}/arquivos/{arquivoId}")
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      .replace(new RegExp("{formularioId}", "g"), payload.formularioId)
      .replace(new RegExp("{arquivoId}", "g"), payload.arquivoId)
      
    return Request.delete(`${url}`)
  },

  downloadArquivo(payload) {
    const url = resource.concat("/arquivos/{arquivoId}")
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      .replace(new RegExp("{arquivoId}", "g"), payload.arquivoId)

    return Request.get(url, {responseType: 'arraybuffer'}).then(function(response) {
      let blob = new Blob([response.data], { type: response.headers.ContentType })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.target="_blank"
      link.rel="noopener noreferrer"
      link.download = response.headers.nomearquivo
      link.click()
    })
  },

  viewArquivo(payload) {
    const url = resource.concat("/arquivos/{arquivoId}")
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      .replace(new RegExp("{arquivoId}", "g"), payload.arquivoId)

    Request.get(url, {responseType: 'arraybuffer'})
      .then(response => response.data) 
        .then(blob => {
          const data = URL.createObjectURL(new Blob([blob], { type: payload.contentType }))
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
          window.URL.revokeObjectURL(blob)
        })
    },

  postListaPresenca(payload) {
    const url = resource.concat("/lista-presenca")
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      
    return Request.post(`${url}`, payload.formulario)
  },

  putListaPresenca(payload) {
    const url = resource.concat("/lista-presenca/{formularioId}")
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      .replace(new RegExp("{formularioId}", "g"), payload.formularioId)

    return Request.put(`${url}`, payload.formulario)    
  },
  
  deleteListaPresenca(payload) {
    const url = resource.concat("/lista-presenca/{formularioId}")
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      .replace(new RegExp("{formularioId}", "g"), payload.formularioId)
    
    return Request.delete(`${url}`)
  },

  
  postFormulario(payload) {
    const url = resource.concat(payload.urlFormulario)
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      
    return Request.post(`${url}`, payload.formulario)
  },

  putFormulario(payload) {
    const url = resource.concat(payload.urlFormulario.concat("/{formularioId}"))
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      .replace(new RegExp("{formularioId}", "g"), payload.formularioId)

    return Request.put(`${url}`, payload.formulario)    
  },
  
  deleteFormulario(payload) {
    const url = resource.concat(payload.urlFormulario.concat("/{formularioId}"))
      .replace(new RegExp("{indicadorId}", "g"), payload.indicadorId)
      .replace(new RegExp("{lancamentoId}", "g"), payload.lancamentoId)
      .replace(new RegExp("{formularioId}", "g"), payload.formularioId)
    
    return Request.delete(`${url}`)
  },  
}